import { useEffect } from 'react';
import { isRouteErrorResponse, useRouteError } from 'react-router';
import { reportError } from '../sentry';

/** Shown instead of a page that crashed. The error itself is already on its way to us. */
export function ErrorFallback() {
  return (
    <div className="auth">
      <div className="auth-card">
        <a className="auth-brand" href="https://vaartix.com">
          <img src="/vaartix-icon.svg" alt="" />
          vaartix
        </a>
        <div className="auth-box">
          <h1>Something went wrong</h1>
          <p>
            This page hit an error and couldn't load. We've been told about it. Your emails, domains
            and keys are not affected.
          </p>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => window.location.reload()}
            >
              Reload the page
            </button>
            <a className="link-btn" href="/emails">
              Go to Emails
            </a>
          </div>
        </div>
        <p className="auth-foot">
          Still stuck? Email <a href="mailto:support@vaartix.com">support@vaartix.com</a> or see{' '}
          <a href="https://status.vaartix.com">status.vaartix.com</a>.
        </p>
      </div>
    </div>
  );
}

/**
 * The router's error screen. React Router catches errors thrown while rendering a route, so
 * they never reach the app's ErrorBoundary: report them here.
 */
export function RouteError() {
  const error = useRouteError();
  useEffect(() => {
    // A 404 from the router is not a crash.
    if (!isRouteErrorResponse(error)) reportError(error);
  }, [error]);
  return <ErrorFallback />;
}
